import { Component, OnInit } from "@angular/core";

@Component({
	selector: "caass-sysadmin",
	templateUrl: "./sysadmin.component.html",
})
export class SysAdminComponent {}
